import React from "react";

const ToolContainerContext = React.createContext({
	container: null,
});

export default ToolContainerContext;
